import { Observable } from 'rxjs';
import { fetchTrainingListAPI } from '../../api/fetch-functions/training';
import { ITrainingInfoType } from '../../types/record/training-info';
import { ListWithPromiseState } from './common/list-with-status';
import {
  fetchIdStreamGenerator,
  fetchListFnGenerator,
  listOfIdFnGenerator,
  oneIdListSetReducerGenerator,
  oneIdListSetStreamGenerator,
  updateStreamGenerator
} from './common/one-id-list';

const fetchSignal$ = fetchIdStreamGenerator();

// 仮引数のリネームのためいったん変数`f`に格納
const f = fetchListFnGenerator(fetchSignal$);
export const fetchTrainingListOf = (modelId: number) => f(modelId);

/**
 * @description
 * `fetchTrainingListOf(modelId)` を実行すると
 * `trainingListSet$` の該当idの要素を re-fetch する．
 */
const updateTrainingList$ = updateStreamGenerator(
  fetchSignal$,
  fetchTrainingListAPI
);

const trainingListSetReducer = oneIdListSetReducerGenerator<
  ITrainingInfoType
>();

/**
 * @description
 * すべての trainingList の集合．必要になったものからfetchして蓄える．
 * 複数のcomponentで共有するため．
 */
const trainingListSet$ = oneIdListSetStreamGenerator(
  updateTrainingList$,
  trainingListSetReducer
);

const g = listOfIdFnGenerator(trainingListSet$);
export const trainingListOf = (
  modelId: number
): Observable<ListWithPromiseState<ITrainingInfoType>> => {
  fetchTrainingListOf(modelId);
  return g(modelId);
};
